import React from 'react';
import { useStyleInjection } from '../../hooks';

export function QuestionDetailSkeleton(): React.ReactElement {
  useStyleInjection(detailSkeletonStyles, 'fmp-detail-skeleton-styles');

  return (
    <div role="status" aria-busy="true" aria-label="Loading question details">
      <div className="fmp-detail-skeleton">
        <div className="fmp-skeleton__title" style={{ width: '80%', height: 'var(--fmp-size-28)' }} />
        <div className="fmp-detail-skeleton__meta">
          <div className="fmp-skeleton__meta" style={{ width: 'var(--fmp-size-120)' }} />
          <div className="fmp-skeleton__meta" style={{ width: 'var(--fmp-size-100)' }} />
        </div>
        <div className="fmp-detail-skeleton__body">
          <div className="fmp-skeleton__meta" style={{ width: '100%', height: 'var(--fmp-size-16)' }} />
          <div className="fmp-skeleton__meta" style={{ width: '90%', height: 'var(--fmp-size-16)' }} />
          <div className="fmp-skeleton__meta" style={{ width: '75%', height: 'var(--fmp-size-16)' }} />
        </div>
        <div className="fmp-detail-skeleton__replies">
          <div className="fmp-skeleton__meta" style={{ width: 'var(--fmp-size-80)', height: 'var(--fmp-size-20)' }} />
          <div className="fmp-detail-skeleton__reply-item">
            <div className="fmp-skeleton__meta" style={{ width: '100%', height: 'var(--fmp-size-16)' }} />
            <div className="fmp-skeleton__meta" style={{ width: '60%', height: 'var(--fmp-size-16)' }} />
            <div className="fmp-skeleton__meta" style={{ width: 'var(--fmp-size-120)', height: 'var(--fmp-size-14)' }} />
          </div>
          <div className="fmp-detail-skeleton__reply-item">
            <div className="fmp-skeleton__meta" style={{ width: '85%', height: 'var(--fmp-size-16)' }} />
            <div className="fmp-skeleton__meta" style={{ width: 'var(--fmp-size-120)', height: 'var(--fmp-size-14)' }} />
          </div>
        </div>
      </div>
      <span className="fmp-visually-hidden">Loading question details...</span>
    </div>
  );
}

const detailSkeletonStyles = `
  :where(.fmp-widget-scope) .fmp-detail-skeleton {
    display: flex;
    flex-direction: column;
    gap: var(--fmp-space-lg);
  }

  :where(.fmp-widget-scope) .fmp-detail-skeleton__meta {
    display: flex;
    gap: var(--fmp-space-md);
    margin-top: var(--fmp-space-xs);
  }

  :where(.fmp-widget-scope) .fmp-detail-skeleton__body {
    display: flex;
    flex-direction: column;
    gap: var(--fmp-space-sm);
    margin-top: var(--fmp-space-sm);
  }

  :where(.fmp-widget-scope) .fmp-detail-skeleton__replies {
    display: flex;
    flex-direction: column;
    gap: var(--fmp-space-md);
    margin-top: var(--fmp-space-lg);
    padding-top: var(--fmp-space-lg);
    border-top: var(--fmp-border-width) solid var(--fmp-color-border);
  }

  :where(.fmp-widget-scope) .fmp-detail-skeleton__reply-item {
    display: flex;
    flex-direction: column;
    gap: var(--fmp-space-sm);
    padding: var(--fmp-space-lg);
    border: var(--fmp-border-width) solid var(--fmp-color-border);
    border-radius: var(--fmp-radius-control);
  }
`;
